export default __webpack_public_path__ + "static/media/img-2.f4dfd9a3.jpg";